export const permissions = {
  VIEW_DASHBOARD: "VIEW_DASHBOARD",
  VIEW_TEMPLATE: "VIEW_TEMPLATE",
  ADD_TEMPLATE: "ADD_TEMPLATE",
  EDIT_TEMPLATE: "EDIT_TEMPLATE",
  VIEW_LOA: "VIEW_LOA",
  VIEW_LOO: "VIEW_LOO",
  EDIT_LOO: "EDIT_LOO",
  ADD_LOO: "VIEW_LOO",
  VIEW_CMU: "VIEW_CMU",
  ADD_LOA: "ADD_LOA",
  EDIT_LOA: "EDIT_LOA",
  APPROVE_LOA: "APPROVE_LOA",
  VIEW_CONTRACT: "VIEW_CONTRACT",
  EDIT_CONTRACT: "EDIT_CONTRACT",
  ADD_CONTRACT: "ADD_CONTRACT",
  APPROVE_CONTRACT: "APPROVE_CONTRACT",
};

export const Roles = {
  ERAMAN_CREATOR: "ERAMAN_CREATOR",
  MAGP_CREATOR: "MAGP_CREATOR",
  APSS_CREATOR: "APSS_CREATOR",
  EMPLOYEEAPP_CREATOR: "EMPLOYEEAPP_CREATOR",
  MAHBCOMM_CREATOR: "MAHBCOMM_CREATOR",
  MAHB_CORPORATE_CREATOR: "MAHB_CORPORATE_CREATOR",
  PASSENGER_CREATOR: "PASSENGER_CREATOR",
  PASSENGER_REVIEWER: "PASSENGER_REVIEWER",
  ERAMAN_REVIEWER: "ERAMAN_REVIEWER",
  MAGP_REVIEWER: "MAGP_REVIEWER",
  APSS_REVIEWER: "APSS_REVIEWER",
  EMPLOYEEAPP_REVIEWER: "EMPLOYEEAPP_REVIEWER",
  MAHBCOMM_REVIEWER: "MAHBCOMM_REVIEWER",
  MAHB_CORPORATE_REVIEWER: "MAHB_CORPORATE_REVIEWER",
  SUPER_ADMIN: "SUPER_ADMIN",
  CENTRALIZED_CREATOR: "CENTRALIZED_CREATOR",
  CENTRALIZED_REVIEWER: "CENTRALIZED_REVIEWER",
  PASSENGER_ECMS_CREATOR: "PASSENGER_ECMS_CREATOR",
  PASSENGER_ECMS_REVIEWER: "PASSENGER_ECMS_REVIEWER"
};
